var exports = {
  "k": "xe564cbfb--2fef05--container",
  "h": "xe564cbfb--2fef05--input",
};

module.exports = exports;
